import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8078fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-navbar__header" }
const _hoisted_2 = { class: "column column--left" }
const _hoisted_3 = { class: "column-block" }
const _hoisted_4 = { class: "column column--center" }
const _hoisted_5 = { class: "column-block" }
const _hoisted_6 = { class: "column column--right" }
const _hoisted_7 = { class: "column-block" }
const _hoisted_8 = { class: "app-navbar__footer" }

import { useAttrs, computed } from 'vue'
import { useRouter } from 'vue-router'
//import { useGlobalStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // 导航栏标题
  title: String,
  // 是否固定导航栏
  fixed: Boolean,
  // 是否显示返回按钮
  showBackButton: {
    type: Boolean,
    default: true,
  }
},
  setup(__props, { emit }) {

const props = __props;





const router = useRouter();
const attrs = useAttrs();
//const globalStore = useGlobalStore()

const styles = computed(() => ({
  position: props.fixed ? 'fixed' : 'static',
  //width: globalStore.clientWidth + 'px',
}))

// 返回按钮事件
const goback = () => {
  if (attrs.onBack) {
    emit('back');
  } else {
    router.go(-1);
  }
}

const onReady = (el: HTMLElement) => {
  emit('ready', el);
}

return (_ctx: any,_cache: any) => {
  const _component_app_navback = _resolveComponent("app-navback")!
  const _component_app_statusbar = _resolveComponent("app-statusbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "app-navbar",
    style: _normalizeStyle(styles.value)
  }, [
    (__props.showBackButton)
      ? (_openBlock(), _createBlock(_component_app_navback, {
          key: 0,
          class: "app-navbar__backbutton",
          onBack: goback
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_app_statusbar, {
      class: "app-navbar__wrapper",
      onReady: onReady
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "left")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createElementVNode("span", null, _toDisplayString(__props.title), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "right")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ]),
      _: 3
    })
  ], 4))
}
}

})